import { useEffect, useState } from 'react';
import api from '../api/axios';

const isNotificationSupported = () => {
  try {
    return (
      typeof window !== 'undefined' &&
      'serviceWorker' in navigator &&
      'PushManager' in window &&
      typeof Notification !== 'undefined'
    );
  } catch { return false; }
};

const getPermission = () => {
  try { return Notification.permission; } catch { return 'denied'; }
};

export function usePushNotifications(user) {
  const [supported,  setSupported]  = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const [permission, setPermission] = useState('default');

  useEffect(() => {
    if (!user) return;
    const supported = isNotificationSupported();
    setSupported(supported);
    if (supported) {
      setPermission(getPermission());
      checkSubscription();
    }
  }, [user]);

  const checkSubscription = async () => {
    try {
      const reg = await navigator.serviceWorker.ready;
      const sub = await reg.pushManager.getSubscription();
      setSubscribed(!!sub);
    } catch {}
  };

  const subscribe = async () => {
    try {
      const reg = await navigator.serviceWorker.register('/sw.js');
      await navigator.serviceWorker.ready;
      const { data } = await api.get('/push/vapid-key');
      if (!data.publicKey) return;
      const appServerKey = urlBase64ToUint8Array(data.publicKey);
      const sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: appServerKey });
      await api.post('/push/subscribe', sub.toJSON());
      setSubscribed(true);
      setPermission('granted');
    } catch (err) {
      console.error('Push subscribe error:', err);
    }
  };

  const unsubscribe = async () => {
    try {
      const reg = await navigator.serviceWorker.ready;
      const sub = await reg.pushManager.getSubscription();
      if (sub) {
        await api.delete('/push/unsubscribe', { data: { endpoint: sub.endpoint } });
        await sub.unsubscribe();
      }
      setSubscribed(false);
    } catch {}
  };

  return { supported, subscribed, permission, subscribe, unsubscribe };
}

function urlBase64ToUint8Array(base64String) {
  try {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64  = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const arr     = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) arr[i] = rawData.charCodeAt(i);
    return arr;
  } catch { return new Uint8Array(); }
}
